<script>

    import { popupStore } from '../stores'

    import Popup from '../$components/popup.svelte'

    $: show = $popupStore === 'volumetric_popup'
    
</script>


<Popup {show}>
    <div class="title">¿Peso volumétrico?</div>
    <p>El peso volumétrico es una medida para calcular un peso «equivalente al volumen» de la mercancía que se transportará.</p>
</Popup>